import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { registerSW } from "virtual:pwa-register";

// Register PWA service worker. 
// In development, this requires 'devOptions.enabled: true' in vite.config.ts
registerSW({ immediate: true });

// Optional: Keep the unregister logic for when you want to specifically disable it, 
// but for now, we enable it to fix the "Install App" button.
/*
if (import.meta.env.DEV && "serviceWorker" in navigator) {
  navigator.serviceWorker
    .getRegistrations()
    .then((regs) => regs.forEach((reg) => reg.unregister()))
    .catch((err) => console.error("SW unregister failed", err));
}
*/

// Prerendered public routes ship real HTML in #root (fast FCP/paint); the SPA
// then mounts on top. We intentionally use createRoot (not hydrateRoot): the
// pages' framer-motion entrance animations start at opacity:0, which would not
// match the visible prerendered snapshot and cause hydration errors. createRoot
// re-renders cleanly with no console errors while still keeping the FCP benefit.
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
